// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YMle1","badges":"styles_badges__261fc"};